import React from 'react'

export default ({ label, name, className, icon, errors = [], ...props }) => {
  const Icon = icon

  return (
    <div className={className}>
      {label && (
        <label className="form-label" htmlFor={name}>
          {label}
          {props?.required && <span className="text-red-500">* </span>}:
        </label>
      )}

      {Icon ? (
        <div className="relative rounded-md shadow-sm">
          <input
            id={name}
            name={name}
            {...props}
            className={`block w-full ${errors.length ? 'error' : ''} border-1 rounded-md bg-gray-100 py-2 pl-2 pr-20 text-gray-900 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6`}
          />

          <div className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3">
            <Icon size={20} />
          </div>
        </div>
      ) : (
        <input
          id={name}
          name={name}
          {...props}
          className={`block w-full ${errors.length ? 'error' : ''} border-1 rounded-md bg-gray-100 py-2.5 pl-2 pr-20 text-gray-900 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6`}
        />
      )}

      {errors && <div className="form-error">{errors}</div>}
    </div>
  )
}
